import React, { useEffect, useState, useCallback } from "react";
import FormSelect from "../../hook-controls/select";
import { GetValidateType } from "../../../module/master/api";

function ComoValidateType({ removeId, ...props }) {
  const [Data, setData] = useState([]);

  const GetListcbx = useCallback(async () => {
    let data = await GetValidateType();
    const cbo =
      data &&
      data
        .map(({ VALIDATE_TYPE_NAME: label, VALIDATE_TYPE: id }) => ({
          label,
          id,
        }))
        .filter((item) => (removeId ? item.id !== removeId : true));
    setData(cbo);
  }, [setData, removeId]);

  useEffect(() => {
    GetListcbx();
  }, [GetListcbx]);

  return (
    <>
      <FormSelect {...props} options={Data} />
    </>
  );
}

export default ComoValidateType;
